import axios from "axios";
import { getAccessToken } from "../utils/authorizationUtils";

let userToken = null;

const instance = axios.create({});

instance.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();
    config.headers["Authorization"] = `Bearer ${accessToken}`;
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  },
);

export default instance;
